import { type FetchResult } from '@apollo/client';

import { client, gql } from './Client';

const addDocumentInfoMutation = gql`
  mutation addDocumentInfo($documentInfo: DocumentInfoInput) {
    addDocumentInfo(documentInfo: $documentInfo)
  }
`;

export interface DocumentInfo {
  eventType: string;
  requestUrl: string;
  fkSite: number;
  fkDiscipline: number;
  documentData: string;
  appVersion: string;
  userAgent: string;
  response: string;
}

const addDocumentInfo = (documentInfo: DocumentInfo): Promise<FetchResult<string>> =>
  client.mutate({ mutation: addDocumentInfoMutation, variables: { documentInfo } });

export { addDocumentInfo };
